/** @jsx jsx */

import { MouseEvent } from 'react';
import { jsx } from '@emotion/core';

import { Button } from '@zapier/design-system';

type Props = {
  onClick: (event: MouseEvent) => void;
};

const VersioningHelpButton = ({ onClick }: Props) => {
  return (
    <Button color="secondary" iconBefore="navHelpFill" onClick={onClick}>
      What is versioning?
    </Button>
  );
};

export default VersioningHelpButton;
